// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import {session} from 'wix-storage';
import wixWindow from 'wix-window';

$w.onReady(function () {
  if(!session.getItem("firstTimePopupShown")) {
    wixWindow.openLightbox("Workshop Registration");
    session.setItem("firstTimePopupShown", "yes");
  }
} );

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")
$w("#group").hide();

	// Click "Preview" to run your code
});

$w.onReady(function () {
	$w("#logoHub").hide();
	// Click "Preview" to run your code
});






$w.onReady(function () {
  $w("#button17").onClick(() => {
    $w('#statebox8').changeState("Day1");
  } );
  $w("#button18").onClick(() => {
    $w('#statebox8').changeState("Day2");
  } );
  $w("#button19").onClick(() => {
    $w('#statebox8').changeState("Day3");
  } );
});